import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const PlayCircle = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Icons/Normal/16px/PlayButton-Circle">
        <path
          id="PlayButton-Circle"
          d="M0 8C0 3.58852 3.58852 0 8 0C12.4115 0 16 3.58852 16 8C16 12.4115 12.4115 16 8 16C3.58852 16 0 12.4115 0 8ZM6.508 10.9507L10.8413 8.28411C10.94 8.22345 11 8.11612 11 8.00012C11 7.88413 10.94 7.7768 10.8417 7.71613L6.50833 5.04957C6.405 4.98624 6.27633 4.98324 6.17067 5.04257C6.06533 5.10157 6 5.2129 6 5.33356V10.6667C6 10.7873 6.06533 10.8987 6.17067 10.9577C6.22133 10.986 6.27733 11 6.33333 11C6.394 11 6.45433 10.9833 6.508 10.9507Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

PlayCircle.displayName = 'PlayCircle';
